import React, { useEffect, useRef, useState } from 'react'
import './App.css'
import './Newpassword.css'
import { Link } from 'react-router-dom'
import Axios from 'axios'
import ClipLoader from 'react-spinners/ClipLoader'
import { useHistory, useLocation } from 'react-router-dom'
import { API_URL } from './config'

const Newpassword = () => {
  const history = useHistory()
  const location = useLocation()

  const { email, accounttype, message, isAffiliate, account_name } = location.state || {}

  const [pass1, setPass1] = useState('')
  const [pass2, setPass2] = useState('')
  const [otp, setOTP] = useState('')

  const [error, setError] = useState('')
  const [errorDisplay, setErrorDisplay] = useState('none')

  const [isOTPCorrect, setIsOTPCorrect] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const [loading, setLoading] = useState(false)
  const [isPasswordSaved, setIsPasswordSaved] = useState(false)

  const timeoutRef = useRef(null)

  useEffect(() => {
    document.title = 'Reset password'

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [])

  const clearError = () => {
    setErrorDisplay('none')
  }

  const showError = (messageText) => {
    setError(messageText)
    setErrorDisplay('block')

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    timeoutRef.current = setTimeout(() => {
      setErrorDisplay('none')
    }, 5000)
  }

  const handleForm = async () => {
    clearError()

    if (!email) {
      showError('Your password reset session has expired. Please start again.')
      return
    }

    if (isOTPCorrect) {
      if (pass1.length < 8) {
        showError('Your password must be at least 8 characters long.')
        return
      }

      if (pass1 !== pass2) {
        showError('Make sure both passwords match.')
        return
      }
    } else {
      if (otp.trim() === '') {
        showError('Enter the OTP sent to you.')
        return
      }
    }

    setDisabled(true)
    setLoading(true)

    const baseURL = `${API_URL}/apps/kscanner/webservices.php`
    const data = new FormData()

    data.append('email', email)
    data.append('account_type', accounttype)
    data.append('isAffiliate', isAffiliate)

    if (isOTPCorrect) {
      data.append('pass1', pass1)
      data.append('pass2', pass2)
      data.append('account_name', account_name)
      data.append('query', 'SAVE-NEW-PASSWORD')
    } else {
      data.append('otp', otp.trim())
      data.append('query', 'VERIFY-OTP-TO-RESET-PASSWORD')
    }

    try {
      const response = await Axios({
        method: 'POST',
        url: baseURL,
        data: data,
        withCredentials: true,
      })

      if (response.data.status === 'success') {
        if (isOTPCorrect && response.data.is_new_password_saved === 'yes') {
          setIsPasswordSaved(true)
        } else {
          setError(response.data.message || 'Identity verified.')
          setErrorDisplay('block')
          setIsOTPCorrect(true)

          if (timeoutRef.current) {
            clearTimeout(timeoutRef.current)
          }

          timeoutRef.current = setTimeout(() => {
            setErrorDisplay('none')
          }, 5000)
        }
      } else {
        showError(response.data.message || 'We could not verify your information.')
      }
    } catch (err) {
      console.log(err)
      showError('Something went wrong. Please try again.')
    } finally {
      setDisabled(false)
      setLoading(false)
    }
  }

  if (isPasswordSaved) {
    return (
      <div className="kx-newpassword-page">
        <div className="kx-newpassword-bg">
          <div className="kx-newpassword-bg__orb kx-newpassword-bg__orb--one"></div>
          <div className="kx-newpassword-bg__orb kx-newpassword-bg__orb--two"></div>
          <div className="kx-newpassword-bg__grid"></div>
          <div className="kx-newpassword-bg__word">KARAMALE</div>
        </div>

        <main className="kx-newpassword">
          <div className="kx-newpassword__success-wrap">
            <div className="kx-newpassword__success-card">
              <Link to="/" className="kx-newpassword__success-logo">
                karamale.
              </Link>

              <div className="kx-newpassword__success-icon">✓</div>

              <span className="kx-newpassword__success-kicker">PASSWORD UPDATED</span>

              <h1>Password saved.</h1>

              <p>
                Your new password has been saved successfully. You can now log in to your Karamale
                account.
              </p>

              <Link to="/login" className="kx-newpassword__success-button">
                <span>Proceed to log in</span>
                <span>→</span>
              </Link>
            </div>
          </div>
        </main>
      </div>
    )
  }

  return (
    <div className="kx-newpassword-page">
      <div className="kx-newpassword-bg">
        <div className="kx-newpassword-bg__orb kx-newpassword-bg__orb--one"></div>
        <div className="kx-newpassword-bg__orb kx-newpassword-bg__orb--two"></div>
        <div className="kx-newpassword-bg__grid"></div>
        <div className="kx-newpassword-bg__word">KARAMALE</div>
      </div>

      <main className="kx-newpassword">
        <div className="kx-newpassword__wrap">
          <section className="kx-newpassword__brand">
            <Link to="/" className="kx-newpassword__logo">
              karamale.
            </Link>

            <div className="kx-newpassword__brand-content">
              <div className="kx-newpassword__eyebrow">ACCOUNT RECOVERY</div>

              <h1>
                Almost
                <strong>back in.</strong>
              </h1>

              <p>
                Verify your identity, choose a new password and get back to everything waiting for
                you on Karamale.
              </p>

              <div className="kx-newpassword__features">
                <div className="kx-newpassword__feature">
                  <span className="kx-newpassword__feature-mark">01</span>
                  <span>Verify your identity</span>
                </div>

                <div className="kx-newpassword__feature">
                  <span className="kx-newpassword__feature-mark">02</span>
                  <span>Create a new password</span>
                </div>

                <div className="kx-newpassword__feature">
                  <span className="kx-newpassword__feature-mark">03</span>
                  <span>Get back to your account</span>
                </div>
              </div>
            </div>

            <div className="kx-newpassword__brand-footer">
              <span>Remember your password?</span>
              <Link to="/login">Log in</Link>
            </div>
          </section>

          <section className="kx-newpassword__panel">
            <div className="kx-newpassword__card">
              <div className="kx-newpassword__card-head">
                <span className="kx-newpassword__card-kicker">
                  {isOTPCorrect ? 'NEW PASSWORD' : 'VERIFY IDENTITY'}
                </span>

                <h2>{isOTPCorrect ? 'Create a new password' : 'Enter your verification code'}</h2>

                <p>
                  {isOTPCorrect
                    ? 'Choose a new password for your Karamale account.'
                    : 'Enter the OTP we sent to verify that it is really you.'}
                </p>
              </div>

              <div className="kx-newpassword__form">
                {!isOTPCorrect && (
                  <>
                    {message && <div className="kx-newpassword__message">{message}</div>}

                    <div className="kx-newpassword__field">
                      <label>Verification code</label>

                      <input
                        type="text"
                        name="code"
                        required
                        autoComplete="one-time-code"
                        inputMode="numeric"
                        placeholder="Enter your OTP"
                        value={otp}
                        onChange={(e) => {
                          setOTP(e.target.value)
                          clearError()
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' && !disabled) {
                            handleForm()
                          }
                        }}
                      />
                    </div>
                  </>
                )}

                {isOTPCorrect && (
                  <>
                    <div className="kx-newpassword__field">
                      <label>New password</label>

                      <input
                        type="password"
                        name="pass1"
                        required
                        autoComplete="new-password"
                        placeholder="At least 8 characters"
                        value={pass1}
                        onChange={(e) => {
                          setPass1(e.target.value)
                          clearError()
                        }}
                      />
                    </div>

                    <div className="kx-newpassword__field">
                      <label>Confirm password</label>

                      <input
                        type="password"
                        name="pass2"
                        required
                        autoComplete="new-password"
                        placeholder="Retype your password"
                        value={pass2}
                        onChange={(e) => {
                          setPass2(e.target.value)
                          clearError()
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' && !disabled) {
                            handleForm()
                          }
                        }}
                      />
                    </div>
                  </>
                )}

                <div className="kx-newpassword__error" style={{ display: errorDisplay }}>
                  {error}
                </div>

                <button
                  type="button"
                  onClick={handleForm}
                  className="kx-newpassword__submit"
                  disabled={disabled}
                >
                  {loading ? (
                    <ClipLoader color="#ffffff" loading={true} size={20} />
                  ) : (
                    <>
                      <span>{isOTPCorrect ? 'Save new password' : 'Verify identity'}</span>

                      <span className="kx-newpassword__submit-arrow">→</span>
                    </>
                  )}
                </button>

                <div className="kx-newpassword__login">
                  <span>Remember your password?</span>
                  <Link to="/login">Log in →</Link>
                </div>

                <Link to="/login" className="kx-newpassword__back">
                  ← Back to login
                </Link>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  )
}

export default Newpassword
